import React, { useEffect, useRef } from "react";
import { micLevel } from "../agent/voice";

const WEIGHTS = [0.35, 0.55, 0.8, 1, 0.85, 1, 0.75, 0.5, 0.3];

/**
 * Dictation: a tool, not a presence. The waveform says the mic is open, the
 * text says what was heard, and the two controls are the only decisions —
 * discard it, or send it. Nothing sends by itself.
 */
const VoiceDictationBar = ({ active, transcript, onSend, onCancel }) => {
  const barsRef = useRef(null);
  const rafRef = useRef(0);
  const smooth = useRef(0);

  useEffect(() => {
    if (!active) return undefined;
    const paint = () => {
      const el = barsRef.current;
      if (el) {
        const level = micLevel();
        smooth.current = level > smooth.current ? level : smooth.current * 0.88 + level * 0.12;
        el.style.setProperty("--level", (smooth.current * (0.75 + Math.random() * 0.5)).toFixed(3));
      }
      rafRef.current = requestAnimationFrame(paint);
    };
    paint();
    return () => cancelAnimationFrame(rafRef.current);
  }, [active]);

  if (!active) return null;
  const ready = Boolean(transcript && transcript.trim());

  return (
    <div className="copilotDictate">
      <div className="copilotDictate__bars" ref={barsRef} aria-hidden="true">
        {WEIGHTS.map((weight, i) => (
          <span key={`b${i + 1}`} className="copilotDictate__bar" style={{ "--weight": weight }} />
        ))}
      </div>
      <div className="copilotDictate__text">
        {ready ? transcript : <span className="copilotDictate__hint">Listening — speak, then send</span>}
      </div>
      <button
        type="button"
        className="copilotDictate__cancel"
        onClick={onCancel}
        title="Discard"
        aria-label="Discard recording"
      >
        <i className="material-icons-round">close</i>
      </button>
      <button type="button" className="copilotDictate__send" onClick={onSend} disabled={!ready}>
        Send
      </button>
    </div>
  );
};

export default VoiceDictationBar;
